import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('posting_preferences'),
    subtitle: defineMessage('how_manual_journals_sho__xero_upon_the_approval'),
    asDraft: defineMessage('as_draft'),
    asPosted: defineMessage('as_posted'),
};
